import "./App.css";
import SearchList from "./components/SearchList";

function App() {
  return (
    <div className="container">
      <p className="header">Rick and Morty Search</p>
      <SearchList />
    </div>
  );
}

export default App;
